import React from "react";
import PredictionPage from "../../components/PredictionPage";

function AUDUSD() {
  return (
    <PredictionPage
      title="AUDUSD"
      content="This is the AUDUSD AI Trading Predictions page."
      canonical="/forex-majors/audusd-ai-trading-predictions"
      categoryKey="nav.forexMajors"
      categoryPath="/forex-majors"
      symbol="AUDUSD"
    />
  );
}

export default AUDUSD;
